import { render, staticRenderFns } from "./active-variation-item.vue?vue&type=template&id=23f0489d&scoped=true&"
import script from "./active-variation-item.vue?vue&type=script&lang=js&"
export * from "./active-variation-item.vue?vue&type=script&lang=js&"
import style0 from "./active-variation-item.vue?vue&type=style&index=0&id=23f0489d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f0489d",
  null
  
)

export default component.exports